var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 96,
    viewBox: "0 0 101 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1567_6420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8887 1.00249H63.39L32.7645 91.7957C32.6079 92.2594 32.38 92.6959 32.089 93.0894C31.7987 93.4832 31.4484 93.8285 31.0509 94.1139C30.6533 94.3993 30.2146 94.6211 29.7485 94.7707C29.2824 94.9202 28.7963 94.9975 28.3078 94.9975H5.34835C4.60306 94.9975 3.86774 94.8205 3.2047 94.479C2.54097 94.1385 1.96802 93.6446 1.53341 93.0383C1.09852 92.432 0.814017 91.731 0.703371 90.9931C0.59245 90.2553 0.65975 89.5013 0.897794 88.7946L29.4307 4.20175C29.5865 3.73813 29.8145 3.30192 30.1062 2.90809C30.3966 2.51426 30.748 2.16903 31.1443 1.88363C31.5419 1.59823 31.9806 1.37638 32.4467 1.22683C32.9128 1.07727 33.3989 1 33.8875 1V1.00125L33.8887 1.00249Z",
    fill: "url(#paint0_linear_1567_6420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2723 94.9975H61.7821C61.4867 94.9975 61.1914 94.97 60.8997 94.9139C60.6093 94.8591 60.3239 94.7769 60.0485 94.6684C59.7731 94.56 59.5088 94.4254 59.2583 94.2684C59.0081 94.1103 58.7732 93.9292 58.5567 93.7275L28.4958 65.6532C28.1779 65.3563 27.9564 64.9708 27.8602 64.5465C27.7641 64.1222 27.7979 63.6788 27.9573 63.274C28.1167 62.8693 28.3942 62.5218 28.7538 62.277C29.114 62.0327 29.539 61.9019 29.9739 61.9019H76.7552L88.2698 94.9987L88.2723 94.9975Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4963 1.0025L42.8451 61.9081L76.5875 61.9007L88.1619 94.9975H61.7715C61.4985 94.995 61.2256 94.9701 60.9564 94.9215C60.6872 94.8729 60.423 94.8018 60.1662 94.7071C59.6514 94.5195 59.1726 94.2451 58.7504 93.8958L38.4581 74.9569L32.7775 91.7098C32.6304 92.1285 32.4285 92.5261 32.1767 92.8912C31.6721 93.6259 30.982 94.2137 30.1764 94.5949C29.7753 94.7847 29.3508 94.9201 28.9139 94.9975H5.3625C4.60973 95 3.86694 94.8205 3.19767 94.4741C2.5283 94.1279 1.95212 93.6256 1.51783 93.0098C1.08354 92.3939 0.803908 91.6825 0.702571 90.9358C0.601602 90.1887 0.68153 89.4284 0.93563 88.7186L29.4224 4.26532C29.5707 3.79297 29.7938 3.34804 30.0829 2.94673C30.3708 2.54542 30.7223 2.19147 31.1211 1.89984C31.5199 1.6082 31.9636 1.38138 32.4335 1.22933C32.9033 1.07728 33.3956 1.00001 33.8904 1.0025H63.4976H63.4963Z",
    fill: "url(#paint1_linear_1567_6420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.103 88.7946C100.341 89.5016 100.408 90.2551 100.299 90.993C100.188 91.7307 99.9037 92.4316 99.4697 93.0382C99.035 93.6442 98.4623 94.1379 97.7989 94.4786C97.1355 94.8193 96.4005 94.9971 95.6548 94.9974H62.7748C63.5201 94.9974 64.2554 94.8192 64.9197 94.479C65.5827 94.1387 66.156 93.6439 66.591 93.0382C67.0259 92.4325 67.3101 91.7309 67.421 90.993C67.5319 90.2552 67.4646 89.5012 67.2266 88.7946L38.6925 4.19921C38.3784 3.26733 37.7799 2.45744 36.9813 1.88358C36.585 1.59817 36.1463 1.37758 35.6814 1.22802C35.2165 1.07847 34.7305 1.00244 34.2432 1.00244H67.1219C67.6105 1.00244 68.0953 1.07847 68.5614 1.22802C69.0263 1.37758 69.465 1.59942 69.8625 1.88358C70.2589 2.16898 70.6091 2.51421 70.8995 2.90679C71.1898 3.29938 71.4167 3.73559 71.5737 4.19921L100.108 88.7946H100.103Z",
    fill: "url(#paint2_linear_1567_6420)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1567_6420",
    x1: 44.6555,
    y1: 7.96933,
    x2: 13.9964,
    y2: 98.5382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1567_6420",
    x1: 54.2151,
    y1: 50.1692,
    x2: 47.1237,
    y2: 52.5746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1567_6420",
    x1: 50.3018,
    y1: 5.32711,
    x2: 83.952,
    y2: 94.9737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1567_6420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.8151,
    height: 94.1855,
    fill: "white",
    transform: "translate(0.592773 0.907227)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.9ff9c45bbef3605bf3a712cd467589fd.svg";
export { ForwardRef as ReactComponent };